<template>
    <div style="background:#F4F4F4">
        <el-row>
            <el-row>
                <el-col :span="18">
                    <div id="chartLine" 
                        ref="chartLine" 
                        style="width:100%; height:330px;background:#ffffff; border-radius: 8px;">
                    </div>
                    <div id="LineChart" 
                        ref="LineChart" 
                        style="width:100%; height:330px;background:#ffffff; border-radius: 8px;">
                    </div>    
                </el-col>
                <el-col :span="6">
                    <div id="pieChart" 
                        ref="pieChart" 
                        style="width:100%; height:330px;background:#ffffff; border-radius: 8px;">
                    </div>    
                    <div id="pieChart2" 
                        ref="pieChart2" 
                        style="width:100%; height:330px;background:#ffffff; border-radius: 8px;">
                    </div>    
                </el-col>
            </el-row>
            <!-- <el-row>
                <el-col>
                    <el-table :data="finalDatas" border style="width: 100%;margin-top:10px"
                        :header-cell-style="headerStyle">
                        <el-table-column prop="oldmanName" label="日期" align="center"></el-table-column>
                        <el-table-column prop="oldAge" label="收入" align="center"></el-table-column>
                        <el-table-column prop="birthday" label="明细" align="center"></el-table-column>
                    </el-table>
                </el-col>
            </el-row> -->
        </el-row>
    </div>
</template>
<script>
import echarts from "echarts";
import util from "@/utils/dayUtil.js";
export default {
    name: "financeView",
    data() {
        return {
            chartLine:null,
            LineChart:null,
            pieChart:null,
            pieChart2:null,
            finalDatas:[],
        };
    },
    methods: {
        drawChartLine() {
            if (this.$refs.chartLine) {
                this.chartLine = echarts.init(this.$refs.chartLine);
                let option = {
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'cross',
                      crossStyle: {
                        color: '#999'
                      }
                    }
                  },
                  title: {
                    text: '月收入统计',
                    subtext: '充值/消费'
                  },
                  legend: {
                    data: ['充值金额', '消费金额', '总流水']
                  },
                  xAxis: [
                    {
                      type: 'category',
                      data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                      axisPointer: {
                        type: 'shadow'
                      }
                    }
                  ],
                  yAxis: [
                    {
                      type: 'value',
                      name: '金额',
                      axisLabel: {
                        formatter: '¥{value}'
                      }
                    },
                  ],
                  series: [
                    {
                      name: '充值金额',
                      type: 'bar',
                      tooltip: {
                        valueFormatter: function (value) {
                          return value + '¥';
                        }
                      },
                      data: [
                        32000, 41900, 31000, 23200, 25600, 17670, 35600, 16200, 37600, 20000, 42400, 32300
                      ]
                    },
                    {
                      name: '消费金额',
                      type: 'bar',
                      tooltip: {
                        valueFormatter: function (value) {
                          return value + '¥';
                        }
                      },
                      data: [
                        24600, 25900, 27000, 26400, 28700, 31707, 17600, 18020, 34807, 18800, 41000, 27300
                      ]
                    },
                    {
                      name: '总流水',
                      type: 'line',
                      tooltip: {
                        valueFormatter: function (value) {
                          return value + '¥';
                        }
                      },
                      data: [41000, 41200, 34300, 47500, 37300, 42200, 40300, 33400, 43000, 36500, 32000, 47500]
                    }
                  ]
                };
                this.chartLine.setOption(option);
            }
        },
        drawLineChart() {
            if (this.$refs.LineChart) {
                this.LineChart = echarts.init(this.$refs.LineChart);
                let option = {
                  title: {
                    text: '欠缴金额统计',
                    subtext: '欠缴人员'
                  },
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'cross'
                    }
                  },
                  toolbox: {
                    show: true,
                  },
                  xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['00:00', '01:15', '02:30', '03:45', 
                           '05:00', '06:15', '07:30', '08:45', 
                           '10:00', '11:15', '12:30', '13:45', 
                           '15:00', '16:15', '17:30', '18:45',
                           '20:00', '21:15', '22:30', '23:45']
                  },
                  yAxis: {
                    type: 'value',
                    axisLabel: {
                      formatter: '¥{value}'
                    },
                    axisPointer: {
                      snap: true
                    }
                  },
                  series: [
                    {
                      name: 'Electricity',
                      type: 'line',
                      smooth: true,
                      data: [300, 280, 250, 260, 270, 300, 550, 500, 400, 390, 380, 390, 400, 500, 600, 750, 800, 700, 600, 400],
                    }
                  ]
                };
                this.LineChart.setOption(option);
            }
        },

        drawPie1() {
            if (this.$refs.pieChart) {
                this.pieChart = echarts.init(this.$refs.pieChart);
                let option = option = {
                  title: {
                    text: '类别统计',
                    left: 'left'
                  },
                  tooltip: {
                    trigger: 'item'
                  },
                  legend: {
                    orient: 'vertical',
                    left: 'right'
                  },
                  series: [
                    {
                      name: 'A',
                      type: 'pie',
                      radius: '50%',
                      data: [
                        { value: 1048, name: '床位费' },
                        { value: 735, name: '护理费' },
                        { value: 580, name: '伙食费' },
                        { value: 484, name: '服务费' },
                        { value: 300, name: '其他费用' }
                      ],
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      }
                    }
                  ]
                };
                this.pieChart.setOption(option);
            }
        },
        drawPie2() {
            if (this.$refs.pieChart2) {
                this.pieChart2 = echarts.init(this.$refs.pieChart2);
                let option = {
                  tooltip: {
                    trigger: 'item'
                  },
                  title: {
                    text: '余额统计',
                    left: 'left'
                  },
                  legend: {
                    top: '10%',
                    left: 'center',
                    selectedMode: false
                  },
                  series: [
                    {
                      name: 'Access From',
                      type: 'pie',
                      radius: ['35%', '55%'],
                      center: ['55%', '65%'],
                      startAngle: 180,
                      label: {
                        show: true,
                        formatter(param) {
                          // correct the percentage
                          return param.name + ' (' + param.percent * 2 + '%)';
                        }
                      },
                      data: [
                        { value: 8, name: '<0' },
                        { value: 3, name: '<2000' },
                        { value: 6, name: '<5000' },
                        { value: 7, name: '<10000' },
                        { value: 4, name: '>30000' },
                        {
                          // make an record to fill the bottom 50%
                          value: 8 + 3 + 6 + 7 + 4,
                          itemStyle: {
                            // stop the chart from rendering this piece
                            color: 'none',
                            decal: {
                              symbol: 'none'
                            }
                          },
                          label: {
                            show: false
                          }
                        }
                      ]
                    }
                  ]
                };
                this.pieChart2.setOption(option);
            }
        },
        //表格头颜色
        headerStyle({ row, column, rowIndex, columnIndex }) {
          if (rowIndex === 0) {
            return "background-color: #D4D4D4;";
          }
        },
    },
    created() {
    },
    mounted: function () {
        this.drawChartLine();
        this.drawLineChart();
        this.drawPie1();
        this.drawPie2();
    },
    destroyed() {
    }
};
</script>
  
<style lang="scss" scoped></style>
  